module.exports = __webpack_public_path__ + "media/vid_phone_case3.01a8fb58.mp4";